import type { CISProviderBehavior } from '../types';

export const defaultCISBehavior: CISProviderBehavior = {
	label: 'Default',
};
